// services/permissionService.js
class PermissionService {
    constructor() {
        this.currentUserPermissions = [];
        this.permissionCache = new Set();
    }

    /**
     * Initialise les permissions de l'utilisateur.
     * Peut recevoir soit un tableau de chaînes aplaties,
     * soit une arborescence (ancienne version).
     */
    setUserPermissions(permissions) {
        if (!permissions) {
            console.warn("⚠️ Permissions vides ou nulles");
            return;
        }


        // ✅ Si c’est un tableau aplati (cas de ton backend)
        if (Array.isArray(permissions) && typeof permissions[0] === "string") {
            this.currentUserPermissions = permissions;
            this.permissionCache = new Set(permissions);
        }
        // 🔄 Sinon, si c’est un arbre (compatibilité future)
        else if (Array.isArray(permissions)) {
            this.currentUserPermissions = [];
            this.permissionCache = new Set();
            this._buildPermissionCacheFromTree(permissions);
        }

        // 🔔 Émettre un événement global pour informer les directives
        window.dispatchEvent(new Event('permissions-updated'));
    }

    /**
     * Construit le cache si on reçoit une arborescence
     */
    _buildPermissionCacheFromTree(nodes, path = '') {
        nodes.forEach(node => {
            const currentPath = path ? `${path}.${node.id}` : node.id;

            if (node.enabled) {
                this.permissionCache.add(currentPath);
                this.currentUserPermissions.push(currentPath);
            }

            if (node.children && node.children.length > 0) {
                this._buildPermissionCacheFromTree(node.children, currentPath);
            }
        });
    }

    /**
     * Vérifie l'accès à une permission spécifique
     */
    hasPermission(permissionPath) {
        if (!this.permissionCache || this.permissionCache.size === 0) {
            console.warn("⚠️ Permissions non initialisées");
            return false;
        }

        return this.permissionCache.has(permissionPath);
    }

    /**
     * Récupère toutes les permissions aplaties
     */
    getFlattenedPermissions() {
        return Array.from(this.permissionCache);
    }

    /**
     * Vérifie plusieurs permissions (boutons complexes)
     */
    hasAnyPermission(permissionPaths) {
        return permissionPaths.some(path => this.hasPermission(path));
    }

    hasAllPermissions(permissionPaths) {
        return permissionPaths.every(path => this.hasPermission(path));
    }








}

export default new PermissionService();
